function Posizione(){
    return (

        <div className="d-flex align-items-center flex-column">
            <h3 id="posizione"> Ecco la nostra posizione: </h3>
            <section id="map">

            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6379.724792776854!2d14.714397134887689!3d36.917554300000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x131199bac6e53417%3A0x1c31c5ce3f9f8427!2sFormaggeria%20E!5e0!3m2!1sit!2sit!4v1640961376710!5m2!1sit!2sit" 
            style={{ display: "block", border:"none", height:"600px", width:"400px"}} />
            </section>
            

            
        </div>


    );
}

export default Posizione;